import React, { Component } from 'react';

class IconWhatsapp extends Component {
  render() {
    return (

      <div class="icon icon-whatsapp">

      <svg viewBox="0 0 49 49" xmlns="http://www.w3.org/2000/svg" xmlnsSerif="http://www.serif.com/"
fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g id="icon-whatsapp" fill="#7ad06d">
        <path id="Shape" d="M23.03.028C10.136.637-.039 11.284 0 24.082a23.734 23.734 0 0 0 2.636 10.829L.065 47.283a.938.938 0 0 0 1.14 1.098l12.228-2.872a24.267 24.267 0 0 0 10.405 2.504c13.179.2 24.168-10.176 24.578-23.237C48.857 10.774 37.202-.641 23.03.028zM37.621 37.3c-3.581 3.551-8.342 5.506-13.407 5.506-2.965 0-5.804-.659-8.438-1.96l-1.703-.841-7.497 1.761 1.578-7.595-.839-1.629a18.47 18.47 0 0 1-2.061-8.534c0-5.021 1.973-9.742 5.554-13.293a19.078 19.078 0 0 1 13.407-5.506c5.064.001 9.825 1.956 13.406 5.506 3.581 3.551 5.553 8.271 5.553 13.293 0 4.976-2.004 9.774-5.553 13.292z"
        />
        <path id="Shape1" serifId="Shape" d="M35.883 29.334l-4.69-1.336a1.759 1.759 0 0 0-1.73.452l-1.147 1.159a1.72 1.72 0 0 1-1.857.389c-2.219-.891-6.886-5.005-8.078-7.063a1.683 1.683 0 0 1 .135-1.878l1.001-1.284a1.72 1.72 0 0 0 .216-1.761l-1.973-4.425c-.473-1.06-1.839-1.368-2.732-.62-1.309 1.098-2.862 2.766-3.051 4.614-.332 3.258 1.077 7.365 6.406 12.297 6.157 5.698 11.088 6.45 14.298 5.679 1.821-.437 3.276-2.19 4.194-3.625a1.73 1.73 0 0 0-.992-2.598z"
        />
    </g>
</svg>

      </div>

    );
  }
}

export default IconWhatsapp;



// WEBPACK FOOTER //
// ./src/assets/components/icons/iconWhatsapp.js